import "leaflet-image-transform/dist/L.ImageOverlay.Transform.min.js";
import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const S11411141 = ({setLoading }) => {
  const map = useMap();
  const transformedImagesRef = useRef([]);
  const popupRef = useRef(null);
  
  
    
  useEffect(() => {
    const opacity = parseFloat(localStorage.getItem('opacity'))
    const imageUrls = [
      '/map/gif/Time_Series_Visualization.gif',
      '/map/gif/Time_Series_Visualization.gif'
    ];

   const coordinates4326 = [[
  [11.58700024222088, 78.76419558339921],  
  [12.550766083605277, 78.76419558339921], 
  [12.550766083605277, 78.51331345815034],  
  [11.58700024222088, 78.51331345815034],  
  [11.58700024222088, 78.76419558339921]   
]];

    const coordinates = coordinates4326[0].map(([lon, lat]) => [lat, lon]);
    const imageCorners = [
      coordinates[3],
      coordinates[0],
      coordinates[1],
      coordinates[2],
    ];

    const transformedImages = [];

    imageUrls.forEach((url) => {
      if (url && imageCorners.length === 4) {
        const transformedImage = L.imageOverlay.transform(url, imageCorners, {
          editable: false,
          interactive: false,
          scalable: false,
          draggable: false,
          rotatable: false,
          fit: true,
            opacity: opacity
        });

        
          transformedImage.addTo(map);
          transformedImages.push(transformedImage);

          const element = transformedImage.getElement();
          if (element) {
            element.style.border = 'none';
            element.style.outline = 'none';
            element.style.boxShadow = 'none';
            
          }
        
      }
    });

    transformedImagesRef.current = transformedImages;

    return () => {
      transformedImages.forEach(image => {
        if (map.hasLayer(image)) {
          map.removeLayer(image);
        }
      });
    };
  }, [map,localStorage.getItem('opacity')]);

  useEffect(() => {
    const imgLayer = transformedImagesRef.current[1];
    if (imgLayer) {
      const img = imgLayer._rawImage;

      if (img) {
        if (img.complete) {
          console.log('✅ Image already loaded (cached).');
          setLoading(false);
        } else {
          setLoading(true);
          img.onload = () => {
            console.log('✅ Image finished loading.');
            setLoading(false);
          };
        }
      }
    }
  }, [setLoading]);

  return null;
};

export default S11411141;
